import { breakpoints, matchBreakpoint } from "../common/utils";

(() => {
  const STICK_WHEN = 400;
  const STICKED_CLASS = "c-where-to-buy--sticked";
  const whereToButBlock = $("[data-sticked-where-to-buy]");
  const whereToButBlockWidth = whereToButBlock.css("width");
  const stickWhereToBuyBlock = event => {
    const scrollPosition = $(event.target).scrollTop();

    if (scrollPosition > STICK_WHEN) {
      whereToButBlock.addClass(STICKED_CLASS);
      whereToButBlock.css("width", whereToButBlockWidth);
    } else {
      whereToButBlock.removeClass(STICKED_CLASS);
      whereToButBlock.css("width", "auto");
    }
  };

  if (whereToButBlock.length && matchBreakpoint(breakpoints.md, "min")) {
    $(window).on("scroll", stickWhereToBuyBlock);
  }
})();
